import "./Massage.module.css";
import Header from "@/reusable_sections/Header";
import OurVisualLegacy from "./sections/OurVisualLegacy";
import CuratedHealingModalities from "./sections/CuratedHealingModalities";
import PatientPerspectives from "./sections/PatientPerspectives";
import WhoHerSphereIsFor from "./sections/WhoHerSphereIsFor";
import Footer from "@/reusable_sections/Footer";
export default function MassagePage() {
  return <div>
      <Header />
      <OurVisualLegacy />
      <CuratedHealingModalities />
      <WhoHerSphereIsFor />
      <PatientPerspectives />
      <Footer />
    </div>;
}